import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaListItem from './media-list-item-model'
import {
  delete_mediaListItem,
  load_mediaListItems,
  store_mediaListItem,
} from './mediaListItem-service'

export const LoadMediaListItemsAsync = createAsyncThunk<any, any>(
  'composer/load/mediaListItem',
  async (params: { uid: string }) => {
    return await load_mediaListItems(params)
  },
)

export const CreateMediaListItemAsync = createAsyncThunk<any, any>(
  'composer/create/mediaListItem',
  async (params: MediaListItem) => {
    return await store_mediaListItem(params)
  },
)

export const DeleteMediaListItemAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaListItem',
  async (params) => {
    return await delete_mediaListItem(params)
  },
)
